import styled from 'styled-components'

export const ErrorMessage = styled.div`
  border-radius: 8px;
  box-shadow: 0px 4px 12px ${(props) => props.theme.colors.neutral.grayscale.A200};
  padding: 16px;
`
